/**
 * 登录模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  {
    name: 'getToken',
    url: '/api/oauth/v1/realms/gsl/protocol/openid-connect/token',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  {
    name: 'update',
    url: '/api/oauth/v1/user/update/password',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  {
    name: 'getUserReload',
    url: '/api/oauth/v1/user/pwd/reload',
  },
]
